import React from 'react';
import { DatabaseIcon, PhoneOffIcon, ShuffleIcon } from 'lucide-react';
import { costCards, leakCards } from '../data/content';
const leakIcons = {
  missed: PhoneOffIcon,
  database: DatabaseIcon,
  chaos: ShuffleIcon
};
export function ProblemSection() {
  return <section id="the-math" aria-labelledby="the-math-title" className="border-b border-white/5 bg-ink-800" data-id="element-190" data-mp="30j0qr08ey70g">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-191" data-mp="39h4g67mirnxj">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-192" data-mp="35garhc19653l">
          The math
        </p>
        <h2 id="the-math-title" className="mt-5 max-w-3xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-193" data-mp="3jglicf2kbjor">
          You pay three portals. Then the leads die in three places.
        </h2>

        <div className="mt-14" data-id="element-194" data-mp="1p454as3iz19c">
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-195" data-mp="1k37p8odtanc2">
            What you pay
          </h3>
          <dl className="mt-6 grid gap-5 md:grid-cols-3" data-id="element-196" data-mp="jeoi4dm8zupa">
            {costCards.map(card => <div key={card.source} className="rounded-xl border border-white/10 bg-ink-700 p-7" data-id="element-197" data-mp="ocq00v7xtnz6">
                <dt className="font-display text-lg font-semibold tracking-tight text-brand" data-id="element-198" data-mp="x4i9b2l86r26">
                  {card.source}
                </dt>
                <dd className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-199" data-mp="122tgt6o1sph8">
                  {card.body}
                </dd>
              </div>)}
          </dl>
        </div>

        <div className="mt-14" data-id="element-200" data-mp="1c2u4f4sy9rr8">
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-201" data-mp="1bzodrl4oahte">
            Where it leaks
          </h3>
          <dl className="mt-6 grid gap-5 md:grid-cols-3" data-id="element-202" data-mp="3dtnlxxmi0j1v">
            {leakCards.map(card => {
            const Icon = leakIcons[card.icon];
            return <div key={card.title} className="rounded-xl border border-white/10 bg-ink-900 p-7" data-id="element-203" data-mp="p090hpuyd6e0">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-204" data-mp="k2h7stmhhg8r">
                    <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-205" data-mp="xyuh3fgv6bc5" />
                  </span>
                  <dt className="mt-5 font-display text-lg font-semibold tracking-tight text-white" data-id="element-206" data-mp="u1ga7ugnofnb">
                    {card.title}
                  </dt>
                  <dd className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-207" data-mp="12z0dta1zqo13">
                    {card.body}
                  </dd>
                </div>;
          })}
          </dl>
        </div>

        <div className="mt-14 max-w-3xl border-l-2 border-brand pl-5" data-id="element-208" data-mp="1cr61i7l7mjah">
          <p className="font-display text-lg leading-relaxed text-white/85 sm:text-xl" data-id="element-209" data-mp="1qp2xp2vr4nom">
            The teams doing 30 or more sides a year are exactly the ones too busy to
            answer. The busyness that built your team is the leak in it.
          </p>
          <p className="mt-4 text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-210" data-mp="25ai998cv7923">
            Respond in 5 minutes instead of 30 and your odds of qualifying the lead go up
            21x. Most buyers sign with the first agent who gets them on the phone.
          </p>
        </div>
      </div>
    </section>;
}